import { fetchAgreementDetails } from '../components/CopAgreementDetails/services/CopAgreementDetails.service';
import { extractNumberFromUrl } from '../services/agreementNumber';

(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    updateBreadcrumbWithAgreementNumber();
  }

  function isSalesforceIdInUrl(): boolean {
    const lastSegment = extractNumberFromUrl();
    
    if (!lastSegment) {
      return false;
    }
    const salesforceIdPattern = /^[a-zA-Z0-9]+$/;
    return salesforceIdPattern.test(lastSegment);
  }

  async function updateBreadcrumbWithAgreementNumber() {
    const breadcrumbElement = document.getElementById('cop-breadcrumb');

    if (!breadcrumbElement) {
      return;
    }

    const activeSpan = breadcrumbElement.querySelector<HTMLElement>('.cmp-breadcrumb__item--active [itemprop="name"]');
    
    if (!activeSpan) {
      return;
    }

    if (!isSalesforceIdInUrl()) {
      return;
    }

    const agreementData = await fetchAgreementDetails();

    if (!agreementData || !agreementData.number) {
      const agreementId = extractNumberFromUrl();
      if (agreementId) {
        activeSpan.textContent = agreementId;
      }
      return;
    }
    activeSpan.textContent = agreementData.number;
  }

})();